import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../_services';
import { useTranslation } from 'react-i18next';

function Register({ history }) {

    const {t} = useTranslation();

    const initialValues = {
        // title: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        acceptTerms: false
    };

    const validationSchema = Yup.object().shape({
        // title: Yup.string()
        //     .required('Title is required'),
        firstName: Yup.string()
            .required(t('firstNameRequired')),
        lastName: Yup.string(),
            // .required(t('lastNameRequired')),
        email: Yup.string()
            .email(t('emailIsInvalid'))
            .required(t('emailIsRequired')),
        password: Yup.string()
            .min(6, t("PasswordAtLeast6Chars") )
            .required(t('passwordIsRequired')),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], t("PasswordsMustMatch") )
            .required(t('confirmPasswordRequired')),
        mobile: Yup.string()
                .required(t('Mobile') + t('isRequired'))
                .matches(
                    /^(\+61)?[0]{0,1}[4]{1}([0-9]{8})$/g,
                t('invalidMobile')
                ),    
        acceptTerms: Yup.bool()
            .oneOf([true], t("termsRequired"))
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        accountService.register(fields)
            .then(() => {
                alertService.success(t('registerSuccess'), { keepAfterRouteChange: true });
                setSubmitting(false);
                //history.push('login'); //onAuthStateChanged will redirect to home
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h3 className="card-header">{t('register')}</h3>
                    <div className="card-body">
                        <div className="form-row">
                            {/* <div className="form-group col">
                                <label>Title</label>
                                <Field name="title" as="select" className={'form-control' + (errors.title && touched.title ? ' is-invalid' : '')}>
                                    <option value=""></option>
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Miss">Miss</option>
                                    <option value="Ms">Ms</option>
                                </Field>
                                <ErrorMessage name="title" component="div" className="invalid-feedback" />
                            </div> */}
                            <div className="form-group col-6">
                                <label>{t('FirstName')}</label>
                                <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col-6">
                                <label>{t('LastName')}</label>
                                <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{t('Email')}</label>
                            <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12 col-sm-6">
                                <label>{t('Password')}</label>
                                <Field name="password" type="password"  placeholder={t("AtLeast6Chars")} className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col-12 col-sm-6">
                                <label>{t('confirmPassword')}</label>
                                <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{t('Mobile')}</label>
                            <Field name="mobile" type="text" placeholder={`${t('eg')} 0412345678`} 
                                className={'form-control' + (errors.mobile && touched.mobile ? ' is-invalid' : '')} />
                            <ErrorMessage name="mobile" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-row mb-3">
                            <Field type="checkbox" name="acceptTerms" id="acceptTerms" className={'form-control w-3r ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')} />
                            <label htmlFor="acceptTerms" className="form-control-plaintext w-auto ml-1">{t('accept')} <Link to="terms-of-use">{t('termCondition')}</Link></label>
                            <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group">
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                {t('register')}
                            </button>
                            <Link to="login" className="btn btn-link">{t('Cancel')}</Link>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Register }; 